import { matchDialogAsPath } from "@/shared/components/RouteDialog";

/**
 * Контент, на странице которого зритель задаёт вопрос: видео или стрим из
 * адреса. Route-диалог кладёт свой URL в историю (openRouteDialog), а
 * прямой заход и так живёт на /video/[id], поэтому хватает location.
 */
export function currentContentId(pathname: string): string | null {
  const match = matchDialogAsPath(pathname);
  if (match?.type === "video") return match.videoId;
  if (match?.type === "stream") return match.streamId;
  return null;
}

/**
 * Продукт, на странице которого зритель задаёт вопрос (/product/<id>, и
 * прямым заходом, и route-диалогом). Это не контент: помощник открывает
 * его через GetProduct, а не GetContent, поэтому id уходит отдельным полем.
 */
export function currentProductId(pathname: string): string | null {
  const match = matchDialogAsPath(pathname);
  return match?.type === "product" ? match.productId : null;
}
